import type { ComponentType } from 'react'
import { TargetChildIcon } from '@/shared/ui/icons/target/TargetChildIcon'
import { TargetYouthIcon } from '@/shared/ui/icons/target/TargetYouthIcon'
import { TargetYoungAdultIcon } from '@/shared/ui/icons/target/TargetYoungAdultIcon'
import { TargetMiddleAgeIcon } from '@/shared/ui/icons/target/TargetMiddleAgeIcon'
import { TargetElderlyIcon } from '@/shared/ui/icons/target/TargetElderlyIcon'
import { TargetDisabledIcon } from '@/shared/ui/icons/target/TargetDisabledIcon'
import { TargetSingleHouseholdIcon } from '@/shared/ui/icons/target/TargetSingleHouseholdIcon'
import { TargetMulticulturalIcon } from '@/shared/ui/icons/target/TargetMulticulturalIcon'
import { TargetDualIncomeIcon } from '@/shared/ui/icons/target/TargetDualIncomeIcon'
import { TargetCaregiverIcon } from '@/shared/ui/icons/target/TargetCaregiverIcon'
import { TargetLowIncomeIcon } from '@/shared/ui/icons/target/TargetLowIncomeIcon'
import { TargetWomenIcon } from '@/shared/ui/icons/target/TargetWomenIcon'
import { TargetSmallBusinessIcon } from '@/shared/ui/icons/target/TargetSmallBusinessIcon'
import { TargetResidentIcon } from '@/shared/ui/icons/target/TargetResidentIcon'

export const TARGET_ICON: Record<string, ComponentType<{ size?: number }>> = {
  tgt_child: TargetChildIcon,
  tgt_youth: TargetYouthIcon,
  tgt_young_adult: TargetYoungAdultIcon,
  tgt_middle_age: TargetMiddleAgeIcon,
  tgt_elderly: TargetElderlyIcon,
  tgt_disabled: TargetDisabledIcon,
  tgt_single_household: TargetSingleHouseholdIcon,
  tgt_multicultural: TargetMulticulturalIcon,
  tgt_dual_income: TargetDualIncomeIcon,
  tgt_caregiver: TargetCaregiverIcon,
  tgt_low_income: TargetLowIncomeIcon,
  tgt_women: TargetWomenIcon,
  tgt_small_business: TargetSmallBusinessIcon,
  tgt_resident: TargetResidentIcon,
}
